import React, {FC, useState, useEffect} from "react"

import {getUserAccountLatestLogosCookie, UserAccountForCookie} from "@irati/utils/cookies/userAccountCookie"
import {FormattedMessage} from "@irati/utils/lang"
import Link, {RouterLink} from "@irati/ui/src/Link"
import {Body, H3} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

import {Card} from "@irati/ui/src/Layout"
import {useTheme} from "@irati/ui/src/global/useTheme"
import LoginBlock from "../../../components/LoginBlock"
import {StyledImage} from "./styled"
import {REDIRECT_STORAGE_KEY} from "../../../constants/login"

interface Props {
  id: string
  userAccounts: UserAccountForCookie[]
}

const AccountLogin: FC<Props> = ({userAccounts}) => {
  const [newAccounts, setNewAccounts] = useState(userAccounts)
  const theme = useTheme()

  const makeUrl = (url: string) => {
    const redirectTo = sessionStorage.getItem(REDIRECT_STORAGE_KEY)
    const pathname = redirectTo ? `/welcome/login/?redirectTo=${encodeURIComponent(redirectTo)}` : "/"
    return `${url}${pathname}`
  }

  const helpLinks = [
    <FormattedMessage
      id="platform.defaultLogin.multipleTenants.help.otherDomain"
      values={{
        link: (
          <RouterLink to="/welcome/login/domain">
            <FormattedMessage id="platform.defaultLogin.multipleTenants.help.other.text" />
          </RouterLink>
        )
      }}
    />,
    <RouterLink to="/welcome/accounts">
      <FormattedMessage id="platform.defaultLogin.multipleTenants.help.accounts" />
    </RouterLink>
  ]

  useEffect(() => {
    if (userAccounts) {
      getUserAccountLatestLogosCookie(userAccounts, window.location.hostname).then((updatedUserAccounts) => {
        setNewAccounts(updatedUserAccounts)
      })
    }
  }, [])

  return (
    <>
      <H3 marginBottom={2} textAlign="center">
        <FormattedMessage id="platform.defaultLogin.multipleTenants.title" />
      </H3>
      <LoginBlock helpLinks={helpLinks}>
        {newAccounts &&
          newAccounts.map(({subdomain, image, url}, index) => {
            return (
              <Link key={`subdomain-${index}`} href={makeUrl(url)}>
                <Card bgColor={theme.colors.greys.lightest} padding={2} marginBottom={3}>
                  <Flex alignItems="center" justifyContent="center">
                    <StyledImage src={image} />
                    <Body small>{subdomain}</Body>
                  </Flex>
                </Card>
              </Link>
            )
          })}
      </LoginBlock>
    </>
  )
}

export default AccountLogin
